<div class="usage-report-container mt-3">
    <div class="row g-3">
        <!-- Filters -->
        <div class="col-sm-12">
            <div class="card rounded-3 mb-3">
                <div class="card-header bg-white">
                    <h6 class="text-sm pt-2">Filter Usage Data</h6>
                </div>
                <div class="card-body">
                    <div class="row g-3">
                        <!-- Date Range Filter -->
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="text-xs fw-bold mb-1">Date Range</label>
                                <div class="d-flex gap-2">
                                    <input type="date" class="form-control form-control-sm" v-model="filter_date_from" />
                                    <input type="date" class="form-control form-control-sm" v-model="filter_date_to" />
                                </div>
                            </div>
                        </div>

                        <!-- Billing Type Filter -->
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="text-xs fw-bold mb-1">Billing Type</label>
                                <select class="form-select form-select-sm" v-model="filter_billing_type">
                                    <option value="">All Types</option>
                                    <option v-for="type in unique_billing_types" :key="type" :value="type">
                                        {{ type }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <!-- Status Filter -->
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="text-xs fw-bold mb-1">Status</label>
                                <select class="form-select form-select-sm" v-model="filter_status">
                                    <option value="">All Statuses</option>
                                    <option v-for="status in unique_statuses" :key="status" :value="status">
                                        {{ status }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <!-- Source Filter -->
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="text-xs fw-bold mb-1">Source</label>
                                <select class="form-select form-select-sm" v-model="filter_source">
                                    <option value="">All Sources</option>
                                    <option v-for="source in unique_sources" :key="source" :value="source">
                                        {{ source }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <!-- Filter Buttons -->
                        <div class="col-12">
                            <div class="d-flex gap-2 justify-content-end">
                                <button class="btn btn-sm btn-bg-info" @click="reset_filters">
                                    Reset Filters
                                </button>
                                <button class="btn btn-sm btn-bg-green" @click="apply_filters">
                                    Apply Filters
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Overall Usage Timeline -->
        <div class="col-sm-12">
            <div class="card rounded-3 mb-3">
                <div class="card-header bg-white">
                    <h6 class="text-sm pt-2">Usage Timeline</h6>
                </div>
                <div class="card-body">
                    <div id="overall-usage-chart"></div>
                </div>
            </div>
        </div>

        <!-- Workflow Usage -->
        <div class="col-sm-6">
            <div class="card rounded-3 mb-3">
                <div class="card-header bg-white">
                    <h6 class="text-sm pt-2">Workflow Usage</h6>
                </div>
                <div class="card-body">
                    <div id="workflow-usage-chart"></div>
                </div>
            </div>
        </div>

        <!-- Status Distribution -->
        <div class="col-sm-6">
            <div class="card rounded-3 mb-3">
                <div class="card-header bg-white">
                    <h6 class="text-sm pt-2">Status Distribution</h6>
                </div>
                <div class="card-body">
                    <div id="status-distribution-chart"></div>
                </div>
            </div>
        </div>

        <!-- Hourly Usage -->
        <div class="col-sm-6">
            <div class="card rounded-3 mb-3">
                <div class="card-header bg-white">
                    <h6 class="text-sm pt-2">Hourly Usage Pattern</h6>
                </div>
                <div class="card-body">
                    <div id="hourly-usage-chart"></div>
                </div>
            </div>
        </div>

        <!-- Billing Type Distribution -->
        <div class="col-sm-6">
            <div class="card rounded-3 mb-3">
                <div class="card-header bg-white">
                    <h6 class="text-sm pt-2">Billing Type Distribution</h6>
                </div>
                <div class="card-body">
                    <div id="billing-type-chart"></div>
                </div>
            </div>
        </div>

        <!-- Revenue vs Cost Analysis -->
        <div class="col-sm-12">
            <div class="card rounded-3 mb-3">
                <div class="card-header bg-white">
                    <h6 class="text-sm pt-2">Revenue vs Cost Analysis</h6>
                </div>
                <div class="card-body">
                    <div id="revenue-cost-chart"></div>
                </div>
            </div>
        </div>

        <!-- Detailed Logs Table -->
        <div class="col-sm-12">
            <div class="card rounded-3 mb-3">
                <div class="card-header bg-white">
                    <h6 class="text-sm pt-2">Detailed Usage Logs</h6>
                </div>
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table table-striped table-hover table-sm text-xs">
                            <thead>
                                <tr>
                                    <th class="text-xs fw-bold">Date</th>
                                    <th class="text-xs fw-bold">Status</th>
                                    <th class="text-xs fw-bold">Billing Type</th>
                                    <th class="text-xs fw-bold">Source</th>
                                    <th class="text-xs fw-bold">Workflow</th>
                                    <th class="text-xs fw-bold">Revenue</th>
                                    <th class="text-xs fw-bold">Cost</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="log in paginated_billing_logs" :key="log.id">
                                    <td>{{ new Date(log.date_created).toLocaleString() }}</td>
                                    <td>
                                        <span v-if="log.status === 'success'" class="badge bg-success">Success</span>
                                        <span v-else-if="log.status === 'failed'" class="badge bg-danger">Failed</span>
                                        <span v-else-if="log.status === 'error'" class="badge bg-warning text-dark">Error</span>
                                        <span v-else>{{ log.status }}</span>
                                    </td>
                                    <td>
                                        <span v-if="log.billing_type.billing_name === 'Success'" class="badge bg-success">Success</span>
                                        <span v-else-if="log.billing_type.billing_name === 'Failed'" class="badge bg-danger">Failed</span>
                                        <span v-else-if="log.billing_type.billing_name === 'User Error'" class="badge bg-warning text-dark">User Error</span>
                                        <span v-else>{{ log.billing_type.billing_name }}</span>
                                    </td>
                                    <td>{{ log.source }}</td>
                                    <td>{{ log.workflow ? log.workflow.workflow_name : 'N/A' }}</td>
                                    <td>R {{ parseFloat(log.client_price).toFixed(2) }}</td>
                                    <td>R {{ parseFloat(log.service_cost).toFixed(2) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Empty State -->
                    <div v-if="billing_logs.length === 0" class="text-center py-5 my-4 text-muted">
                        <i class="fas fa-file-alt fa-3x mb-3 text-secondary"></i>
                        <h6>No logs found</h6>
                        <p class="text-xs text-muted">There are no usage logs matching your filters.</p>
                    </div>

                    <!-- Pagination -->
                    <div class="d-flex justify-content-between align-items-center mt-3" v-if="billing_logs.length > 0">
                        <div class="text-xs text-muted">
                            Showing {{ (logs_current_page - 1) * logs_items_per_page + 1 }} to
                            {{ Math.min(logs_current_page * logs_items_per_page, billing_logs.length) }}
                            of {{ billing_logs.length }} entries
                        </div>
                        <div class="d-flex align-items-center">
                            <button class="btn btn-sm btn-outline-secondary me-2" @click="previous_logs_page"
                                :disabled="logs_current_page === 1">
                                <i class="fas fa-arrow-left"></i>
                            </button>
                            <span class="text-xs mx-2">Page {{ logs_current_page }} of {{ logs_total_pages }}</span>
                            <button class="btn btn-sm btn-outline-secondary ms-2" @click="next_logs_page"
                                :disabled="logs_current_page === logs_total_pages">
                                <i class="fas fa-arrow-right"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>